/*! Oil Bundle helper PNM-Advent-v8-2025-09-12 */

(function () {
  'use strict';

  var BUNDLES = {
    travel: {
      bases: [
        '/collections/pure-oil-travel-diffusers',
        '/collections/travel-diffusers',
        '/collections/travel-diffuser',
      ],
      forward: '/collections/pure-oils?bundle=travel&popup=1',
    },
    car: {
      bases: [
        '/collections/car-fresheners',
        '/collections/car-freshener',
        '/collections/car-diffusers',
        '/collections/pure-oil-car-fresheners',
      ],
      forward: '/collections/pure-oils?bundle=car&popup=1',
    },
  };

  function detectBundleTypeFromPath(pathname) {
    var keys = Object.keys(BUNDLES);
    for (var k = 0; k < keys.length; k++) {
      var key = keys[k],
        cfg = BUNDLES[key];
      for (var i = 0; i < cfg.bases.length; i++) {
        if (pathname.indexOf(cfg.bases[i]) === 0) return key;
      }
    }
    return null;
  }

  // Intercept base bundle add (diffuser or car freshener)
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f.matches('form[action*="/cart/add"]')) return;
      var type = detectBundleTypeFromPath(location.pathname);
      if (!type) return; // not our base
      e.preventDefault();
      e.stopPropagation();

      var bk =
        'ob_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      try {
        sessionStorage.setItem('pnm_oil_bundle_key', bk);
        sessionStorage.setItem('pnm_oil_bundle_type', type);
      } catch (_) {}

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: new FormData(f),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('fail');
          return r.json();
        })
        .then(function () {
          window.location.href =
            BUNDLES[type].forward + '&bk=' + encodeURIComponent(bk);
        })
        .catch(function () {
          try {
            f.submit();
          } catch (_) {
            window.location.href = '/cart';
          }
        });
    },
    true
  );

  // Intercept oil add during bundle
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f.matches('form[action*="/cart/add"]')) return;
      if (location.pathname.indexOf('/collections/pure-oils') !== 0) return;
      var p = new URLSearchParams(location.search);
      var bundle = p.get('bundle');
      if (!bundle) return;
      e.preventDefault();
      e.stopPropagation();

      var idInput = f.querySelector('input[name="id"]');
      var vid = idInput && idInput.value;
      if (!vid) {
        try {
          f.submit();
        } catch (_) {}
        return;
      }

      var bk =
        p.get('bk') ||
        sessionStorage.getItem('pnm_oil_bundle_key') ||
        'ob_' + Math.random().toString(36).slice(2);
      var label = bundle === 'travel' ? 'Travel Diffuser' : 'Car Freshener';

      var items = [
        {
          id: Number(vid),
          quantity: 1,
          properties: {
            _free: '1',
            _oil_bundle_child: '1',
            Bundle: label,
            'Bundle group': bk,
          },
        },
      ];

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('fail');
          return r.json();
        })
        .then(function () {
          // Show "Spend to Save" popup for car bundles
          if (bundle === 'car') {
            if (typeof showCFKRefillPopup === 'function') {
              showCFKRefillPopup();
            } else {
              // Discounts are now applied automatically, redirect directly to cart
              window.location.href = '/cart';
            }
          } else {
            window.location.href = '/cart?bundle=' + encodeURIComponent(bundle);
          }
        })
        .catch(function () {
          alert('Could not add oil. Please try again.');
        });
    },
    true
  );

  // Cosmetic toggle on oils collection for bundle sessions
  (function () {
    var p = new URLSearchParams(location.search);
    if (
      location.pathname.indexOf('/collections/pure-oils') === 0 &&
      p.get('bundle')
    ) {
      document.documentElement.classList.add('pnm-oil-bundle');
    }
  })();
})();
